import moment from "moment";

export default function toHumanDate(date:any) {
    let now = new Date();
    let offset = now.getTimezoneOffset();
    let dateData = moment.tz(Date.parse(date), 'UTC');
    // console.log('dddddddddd',));
    
    let dataAnswer = dateData.add((offset * (-1)), 'm').toNow();
    let momentNow = moment();
    if (momentNow.diff(dateData,'years') > 0) {
        dataAnswer = dateData.format('LL')
    }else if (momentNow.diff(dateData,'days') > 5) {
        dataAnswer = dateData.format('MMMM D')
        
    }

    return dataAnswer;
}